import React from "react";
import styles from "./styles.module.css";
import ProgressBar from "../ProgressBar";

/**
 * Reusable KPI stats card for dashboard metrics.
 * Props:
 * - title: string
 * - value: React.ReactNode | string | number
 * - selected: boolean (controls highlight/border/bg)
 * - onClick: function
 * - className: string (optional) to extend/override wrapper class
 * - style: object (optional) to extend inline styles
 */
const StatsCard = ({
  title,
  value,
  selected = false,
  onClick,
  className = "",
  style = {},
  // optional progress props
  progressPercentage,
  progressBackgroundColor,
  progressHeight,
  showProgressPercentage = false,
}) => {
  const mergedStyle = {
    border: selected ? "2px solid var(--primary)" : "",
    backgroundColor: selected ? "#E9F5FF" : "",
    cursor: onClick ? "pointer" : "default",
    ...style,
  };

  return (
    <div
      className={`${styles.dash_item} ${className}`}
      onClick={onClick}
      style={mergedStyle}
    >
      <p className={styles.quantity}>{value}</p>
      <p className={styles.heading}>{title}</p>
      {typeof progressPercentage === "number" && (
        <ProgressBar
          percentage={progressPercentage}
          backgroundColor={progressBackgroundColor}
          height={progressHeight}
          showPercentage={showProgressPercentage}
        />
      )}
    </div>
  );
};

export default StatsCard;
